import React from "react"

import { HighlightedText } from "@/components/HighlightText"

interface HighlightedContentEditableProps {
  value: string
  onChange: (newValue: string) => void
  onBlur: (element: HTMLDivElement) => void
  highlightText: string
  isCurrentMatch: boolean
  className?: string
  style?: React.CSSProperties
}

// contentEditable value that renders its find-and-replace match highlighting.
export const HighlightedContentEditable: React.FC<
  HighlightedContentEditableProps
> = ({
  value,
  onChange,
  onBlur,
  highlightText,
  isCurrentMatch,
  className,
  style,
}) => {
  return (
    <div
      contentEditable
      suppressContentEditableWarning
      onInput={(e) => {
        const newValue = e.currentTarget.textContent || ""
        onChange(newValue)
      }}
      onBlur={(e) => onBlur(e.currentTarget)}
      className={className}
      style={style}
    >
      <HighlightedText
        text={value}
        searchText={highlightText}
        isCurrentMatch={isCurrentMatch}
      />
    </div>
  )
}
